/**
 * OtpInput - UI Layer
 * Campo único numérico para códigos OTP / TOTP.
 * - `inputMode="numeric"` + `autoComplete="one-time-code"` para el autollenado del SO.
 * - Descarta cualquier no-dígito y trunca a `maxLength`.
 * - Enter dispara `onSubmit` solo cuando el código está completo.
 */

import { useRef, useEffect } from 'react';
import type { KeyboardEvent } from 'react';
import { Input } from '@/components/ui/Input';

interface OtpInputProps {
  value: string;
  onChange: (value: string) => void;
  maxLength: number;
  onSubmit?: () => void;
  disabled?: boolean;
  label?: string;
}

export function OtpInput({
  value,
  onChange,
  maxLength,
  onSubmit,
  disabled,
  label,
}: OtpInputProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    ref.current?.focus();
  }, []);

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && value.length === maxLength) {
      onSubmit?.();
    }
  };

  return (
    <Input
      ref={ref}
      type="text"
      inputMode="numeric"
      autoComplete="one-time-code"
      value={value}
      maxLength={maxLength}
      {...(disabled !== undefined ? { disabled } : {})}
      {...(label !== undefined ? { label } : {})}
      onChange={(e) =>
        onChange(e.target.value.replace(/\D/g, '').slice(0, maxLength))
      }
      onKeyDown={handleKeyDown}
    />
  );
}
